module.exports = __webpack_public_path__ + "img/25i.7bf251db.png";